import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { TOKEN_LIST } from '../config/constants';

const TokenSelector = ({ 
  selectedToken, 
  onTokenSelect, 
  excludeToken = null,
  label = "Select Token",
  disabled = false 
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const availableTokens = TOKEN_LIST.filter(token => 
    !excludeToken || token.address !== excludeToken.address
  );

  const handleTokenSelect = (token) => {
    onTokenSelect(token);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <label className="block text-sm font-medium text-white/80 mb-2">
        {label}
      </label>
      
      <button
        type="button"
        onClick={() => !disabled && setIsOpen(!isOpen)}
        disabled={disabled}
        className={`
          w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl
          backdrop-blur-sm text-white text-left flex items-center justify-between
          transition-all duration-200 hover:bg-white/10 hover:border-white/20
          focus:outline-none focus:ring-2 focus:ring-blue-500/50
          ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
        `}
      >
        {selectedToken ? (
          <div className="flex items-center space-x-3">
            <img 
              src={selectedToken.logo} 
              alt={selectedToken.symbol}
              className="w-8 h-8 rounded-full object-contain bg-white/10 p-1"
            />
            <div>
              <div className="font-semibold">{selectedToken.symbol}</div>
              <div className="text-sm text-white/60">{selectedToken.name}</div>
            </div>
          </div>
        ) : (
          <span className="text-white/60">Select a token</span>
        )}
        
        <ChevronDownIcon 
          className={`w-5 h-5 text-white/60 transition-transform duration-200 ${
            isOpen ? 'rotate-180' : ''
          }`}
        />
      </button>

      {isOpen && (
        <div className="absolute top-full left-0 right-0 mt-2 bg-gray-900/95 backdrop-blur-xl border border-white/20 rounded-xl shadow-2xl z-50 max-h-64 overflow-y-auto">
          {availableTokens.map((token) => (
            <button
              key={token.address}
              onClick={() => handleTokenSelect(token)}
              className="w-full px-4 py-3 text-left hover:bg-white/15 transition-colors duration-150 first:rounded-t-xl last:rounded-b-xl flex items-center space-x-3"
            >
              <img 
                src={token.logo} 
                alt={token.symbol}
                className="w-8 h-8 rounded-full object-contain bg-white/10 p-1"
              />
              <div>
                <div className="font-semibold text-white">{token.symbol}</div>
                <div className="text-sm text-white/60">{token.name}</div>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default TokenSelector;